module.exports = __webpack_public_path__ + "img/date.47b3ef54.svg";